import React, { useEffect, useState } from 'react'
import { Link, Outlet, useLocation, useParams } from 'react-router-dom'
import subFileViewIcon from '../../../../_metronic/assets/images/svg/data-room/sub-file-view-breadcrum-icon.svg'
import FileAllLinksTableRow from '../components/FileAllLinksTableRow'
import { useIntl } from 'react-intl'
import { useAuth } from '../../auth'
import { toast } from 'react-toastify'
import { getAllShareLinksFiles, getSingleContent } from '../core/_requests'
import { DateTime } from 'luxon'
import { Spinner } from '../../widgets/components/General/Spinner'
import { useMoveToFolderData } from '../core/FileToFolderAuth'
import { CreateLinkDrawer } from '../components/data-room-drawer/CreateLinkDrawer'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import NoDataPage from '../../widgets/components/NoDataPage'
import ViewFileModal from './ViewFileModal'

function MainFileView() {
  const [singleContentLoading, setSingleContentLoading] = useState(false)
  const [singleContentData, setSingleContentData] = useState<any>()
  const {
    setContentName,
    contentName,
    setShareLinkApiLoading,
    setShareLinkApiData,
    shareLinkApiData,
    setCreateLinkDrawer,
  } = useMoveToFolderData()
  const [showViewFileModal, setShowViewFileModal] = useState<boolean>(false)
  const [fileOriginalNameToView, setFileOriginalNameToView] = useState<string>('')
  const { companyId } = useAuth()
  const location = useLocation()
  const { formatMessage } = useIntl()
  const { contentId } = useParams()

  const getSingleContentById = async () => {
    try {
      setSingleContentLoading(true)
      if (companyId && contentId) {
        const {
          data: { data, success, errors },
        } = await getSingleContent(companyId, contentId)
        if (success) {
          setSingleContentData(data)
          setFileOriginalNameToView(data?.content?.file?.name)
          setContentName(data?.content?.file?.name.split('/').pop())
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setSingleContentLoading(false)
    }
  }

  useEffect(() => {
    getSingleContentById()
  }, [companyId, contentId]) // eslint-disable-line react-hooks/exhaustive-deps

  const getAllShareLinksByContentId = async () => {
    try {
      setShareLinkApiLoading(true)
      if (contentId) {
        const {
          data: { data, success, errors },
        } = await getAllShareLinksFiles(contentId)
        if (success) {
          setShareLinkApiData(data)
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setShareLinkApiLoading(false)
    }
  }

  useEffect(() => {
    getAllShareLinksByContentId()
  }, [contentId]) // eslint-disable-line react-hooks/exhaustive-deps

  function getTimeDifference(date: any) {
    const minutes = Math.abs(
      Math.floor(
        date &&
        DateTime.utc().diff(DateTime.fromISO(date), ['days', 'hours', 'minutes']).toObject()
          .minutes
      )
    )

    const days = Math.abs(
      Math.floor(
        date &&
        DateTime.utc().diff(DateTime.fromISO(date), ['days', 'hours', 'minutes']).toObject().days
      )
    )

    const hours = Math.abs(
      Math.floor(
        date &&
        DateTime.utc().diff(DateTime.fromISO(date), ['days', 'hours', 'minutes']).toObject().hours
      )
    )
    if (days === 0 && hours === 0) {
      return `${minutes} ${formatMessage({ id: 'min ago' })}`
    }
    if (days === 0) {
      return `${hours} ${formatMessage({ id: 'hrs ago' })}`
    } else if (days === 7) {
      return `${formatMessage({ id: '1 week' })}`
    } else if (days < 7) {
      return `${days} ${formatMessage({ id: 'days ago' })}`
    } else if (days > 7) {
      return `${days} ${formatMessage({ id: 'days ago' })}`
    } else {
      return DateTime.fromISO(date).toFormat('MMM dd')
    }
  }

  const handleCreateLinkClick = () => {
    setCreateLinkDrawer(true)
  }

  const handleViewClick = () => {
    setShowViewFileModal(true)
  }

  return (
    <>
      {singleContentLoading ? <Spinner /> : ''}
      <div className='main-file-view-wrapper'>
        <div className='file-view-SubToolbar-wrapper d-flex flex-row align-items-center justify-content-between'>
          <div className='file-view-SubToolbar-left'>
            <ul className='breadcrumb  text-muted  font-size-13 font-weight-600 '>
              {/* <li className='breadcrumb-item pe-3 text-primary '>
              <img src={subFileViewIcon} className='me-2' alt='' />
              <span className='pe-3'>{formatMessage({id: 'My Data'})}</span>
            </li>
            <li className='breadcrumb-item pe-3 text-primary '>
              <span className='pe-3'>{formatMessage({id: 'Files'})}</span>
            </li>
            <li className='breadcrumb-item pe-3 text-muted'>{formatMessage({id: 'Richard'})}</li> */}
              {singleContentData?.breadcrumb &&
                [...(singleContentData?.breadcrumb || [])]
                  .reverse()
                  .map((item: any, index: number) => (
                    <li key={index} className={`breadcrumb-item pe-3 `}>
                      {index === 0 && <img src={subFileViewIcon} className='me-2' alt='' />}
                      <Link to='/data-rooms/files' className='text-muted'>
                        <span
                          className={`pe-3 ${index === singleContentData.breadcrumb.length - 1 ? '' : 'pe-3'
                            }`}
                        >
                          {item.name}
                        </span>
                      </Link>
                      {index === singleContentData.breadcrumb.length - 1 && (
                        <>
                          <span>/</span>
                          <h5 className='font-size-13 font-weight-600 ms-2 mb-0'>
                            {singleContentData?.content?.file?.name.split('/').pop()}
                          </h5>
                        </>
                      )}
                    </li>
                  ))}
            </ul>
          </div>
          <div className='file-view-SubToolbar-right d-none d-md-flex'>
            {/* <a
            href='http://example.com/'
            className='btn btn-outline btn-outline-solid btn-outline-default font-size-13 font-weight-500  mb-2'
          >
            {formatMessage({id: 'Compress'})}
          </a>
          <a
            href='http://example.com/'
            className='btn btn-outline btn-outline-solid btn-outline-default font-size-13 font-weight-500  mb-2'
          >
            {formatMessage({id: 'Move'})}
          </a> */}
          </div>
        </div>
        <main className='file-view-main-wrapper bg-white rounded-2 mt-4 p-6'>
          <div className='d-flex justify-content-between align-items-center'>
            <div className='d-flex gap-4 align-items-center'>
              <div className=''>
                {singleContentData &&
                  singleContentData?.content?.file?.name.split('.').pop() === 'pdf' && (
                    <img
                      height={44}
                      width={44}
                      alt={formatMessage({ id: 'pdf' })}
                      src={toAbsoluteUrl(`/media/icons/file_extensions/${singleContentData?.content?.file?.name.split('.').pop()}.svg`)}
                    />
                  )}
                {singleContentData &&
                  (singleContentData?.content?.file?.name.split('.').pop() === 'docx' ||
                    singleContentData?.content?.file?.name.split('.').pop() === 'doc') && (
                    <img
                      height={44}
                      width={44}
                      alt={formatMessage({ id: 'docx' })}
                      src={toAbsoluteUrl(`/media/icons/file_extensions/${singleContentData?.content?.file?.name.split('.').pop()}.svg`)}
                    />
                  )}
                {singleContentData &&
                  (singleContentData?.content?.file?.name.split('.').pop() === 'pptx' ||
                    singleContentData?.content?.file?.name.split('.').pop() === 'ppt') && (
                    <img
                      height={44}
                      width={44}
                      alt={formatMessage({ id: 'pptx' })}
                      src={toAbsoluteUrl(`/media/icons/file_extensions/${singleContentData?.content?.file?.name.split('.').pop()}.svg`)}
                    />
                  )}
                {singleContentData &&
                  (singleContentData?.content?.file?.name.split('.').pop() === 'jpg' ||
                    singleContentData?.content?.file?.name.split('.').pop() === 'png' ||
                    singleContentData?.content?.file?.name.split('.').pop() === 'jpeg') && (
                    <img
                      height={44}
                      width={44}
                      alt={formatMessage({ id: 'blank' })}
                      src={toAbsoluteUrl('/media/svg/files/blank-image-single.svg')}
                    />
                  )}
                {singleContentData &&
                  !(
                    singleContentData?.content?.file?.name.split('.').pop() === 'pdf' ||
                    singleContentData?.content?.file?.name.split('.').pop() === 'docx' ||
                    singleContentData?.content?.file?.name.split('.').pop() === 'doc' ||
                    singleContentData?.content?.file?.name.split('.').pop() === 'pptx' ||
                    singleContentData?.content?.file?.name.split('.').pop() === 'ppt' ||
                    singleContentData?.content?.file?.name.split('.').pop() === 'jpg' ||
                    singleContentData?.content?.file?.name.split('.').pop() === 'png' ||
                    singleContentData?.content?.file?.name.split('.').pop() === 'jpeg'
                  ) && (
                    <img
                      height={44}
                      width={44}
                      alt={formatMessage({ id: 'blank' })}
                      src={toAbsoluteUrl('/media/svg/files/blank-image-single.svg')}
                    />
                  )}
              </div>
              <div className=''>
                <h5 className='font-size-16 lh-base'>
                  {singleContentData?.content?.file?.name.split('/').pop()}
                </h5>
                <div className='font-size-12 d-flex gap-1'>
                  <p className='m-0'>{formatMessage({ id: 'Last Updated' })}</p><p className='m-0'>{getTimeDifference(singleContentData?.content?.updatedAt)}</p>
                </div>
              </div>
            </div>
            <div className='d-flex gap-2 align-items-center'>
              {/* <div className='more-option  margin_right-8px'>
              <img src={EyeIcon} alt=''></img>
            </div> */}
              {/* <div className='more-option  margin_right-8px'>
              <img src={FileUploadIcon} alt=''></img>
            </div> */}
              <button
                onClick={handleViewClick}
                type='button'
                className='refer-btn-hover btn btn-outline-primary text-primary custom-button-property flex-nowrap font-size-13 text-white font-weight-400 height-36 d-flex align-items-center justify-content-center flex-grow-1 w-100 w-md-auto'
              >
                {formatMessage({ id: 'View ' })}
              </button>
              <button
                onClick={handleCreateLinkClick}
                type='button'
                className='btn bg-primary custom-button-property flex-nowrap font-size-13 text-white font-weight-400 height-36 d-flex align-items-center justify-content-center flex-grow-1 w-100 w-md-auto'
              >
                {formatMessage({ id: 'Create Link' })}
              </button>

              {/* <div className='more-option '>
              <img src={MoreOptionIcon} alt=''></img>
            </div> */}
            </div>
          </div>
          <div className='main-file-view-nav border-bottom border-muted'>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 flex-nowrap'>
              <li className='nav-item mobile-tab font-size-13'>
                <Link
                  className={
                    `nav-link text-active-primary me-4 ` +
                    (location.pathname.includes('main-file-activity-view') && 'active')
                  }
                  to={`/data-rooms/file-view/main-file-view/main-file-activity-view/${contentId}`}
                >
                  {formatMessage({ id: 'Activity' })}
                </Link>
              </li>
              <li className='nav-item mobile-tab font-size-13'>
                <Link
                  className={
                    `nav-link text-active-primary me-6 ` +
                    (location.pathname.includes('main-file-performance-view') && 'active')
                  }
                  to={`/data-rooms/file-view/main-file-view/main-file-performance-view/${contentId}`}
                >
                  {formatMessage({ id: 'Performance' })}
                </Link>
              </li>
            </ul>
          </div>
          <Outlet />
        </main>
        <div className='file-view-all-links-wrapper bg-white mt-4 rounded-2 p-6 mb-4'>
          <h5 className='font-size-16 lh-base text-dark'>
            {formatMessage({ id: 'All Links' })}
          </h5>
          <div className='table-responsive'>
            {shareLinkApiData.length > 0 ? (
              <table className='table table-row-bordered  space-table'>
                <thead>
                  <tr className=' '>
                    <th>{formatMessage({ id: 'Name' })}</th>
                    <th>{formatMessage({ id: 'Link' })}</th>
                    <th>{formatMessage({ id: 'Last active' })}</th>
                    <th>{formatMessage({ id: 'Enabled' })}</th>
                    <th>{formatMessage({ id: 'Visits' })}</th>
                    <th>{formatMessage({ id: 'Actions' })}</th>
                  </tr>
                </thead>
                <tbody>
                  {shareLinkApiData.map((item: any) => (
                    <FileAllLinksTableRow
                      key={item.id}
                      data={item}
                      contentId={contentId}
                      getAllShareLinksByContentId={getAllShareLinksByContentId}
                    />
                  ))}
                </tbody>
              </table>
            ) : (
              <NoDataPage mainfileActivity={true} />
            )}
          </div>
        </div>
      </div>
      <CreateLinkDrawer contentId={contentId} />
      <ViewFileModal
        showViewFileModal={showViewFileModal}
        setShowViewFileModal={setShowViewFileModal}
        fileOriginalNameToView={fileOriginalNameToView}
        fileContentName={contentName}
      />
    </>
  )
}

export default MainFileView
